import React from 'react';
import Sidebar, { Content } from '~co/screen/splitview/sidebar';

import Header from './header';
import Pages from './pages';
import App from './app';
import User from './user';

export default function SettingsSidebar() {
  return (
    <Sidebar>
      <Header />

      <Content className='overflow-auto'>
        <User />
        <br />

        <Pages />
        <br />

        <App />
      </Content>
    </Sidebar>
  );
}
